/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SelfCheckinState {
  Registration = 'REGISTRATION',
  WaitingForConsignee = 'WAITING_FOR_CONSIGNEE',
  ConsigneeSigned = 'CONSIGNEE_SIGNED',
  CheckinFinished = 'CHECKIN_FINISHED'
}
